
const phoneFormRows = document.querySelectorAll('.form-field.has-phone-input');
phoneFormRows.forEach(formRow => {

    //Input hidden in cui inserire valore prefisso + valore input:
    const fullNumberInput = formRow.querySelector('.full-number');
    //Contiene la sigla del prefisso:
    const prefixNumberWrapper = formRow.querySelector('.prefix-number-wrapper');
    //Span in cui fare push del numero del prefisso selezionato:
    const spanPrefixNumberWrapper = prefixNumberWrapper.querySelector('.span-of-selected-prefix');
    //Lista generale contente searchbar + prefissi:
    const prefixesListWrapper = formRow.querySelector('.prefixes-list-wrapper');
    //Searchbar:
    const prefixesSearchbar = prefixesListWrapper.querySelector('.prefix-searchbar');
    // Singoli prefissi:
    const prefixesItems = prefixesListWrapper.querySelectorAll('.list-item');
    //Div in cui fare push della sigla del prefisso selezionato:
    const prefixNameWrapper = formRow.querySelector('.prefix-name-wrapper');
    //Input da cui recuperare numero inserito da user
    const mainInput = formRow.querySelector('.main-number-wrapper');

    // console.log(fullNumberInput,prefixNameWrapper,spanPrefixNumberWrapper,prefixesListWrapper,prefixesSearchbar,prefixesItems,prefixNameWrapper,mainInput)
    
    // Funzione che aggiorna il valore finale nel campo hidden
    function updateFullNumber() {
        const prefix = spanPrefixNumberWrapper.textContent.trim();
        const number = mainInput.value.trim();
        if(number === '') {
            fullNumberInput.value='';
            formRow.classList.remove('typed-in');
        } else {
            fullNumberInput.value = `${prefix}${number}`;
            formRow.classList.add('typed-in');
        }
    }

    // Aggiunta classe per fake outline al click su elementi fake input:
    prefixNumberWrapper.addEventListener('click', () => {
        formRow.classList.add('row-is-clicked');
    });
    mainInput.addEventListener('click', () => {
        formRow.classList.add('row-is-clicked');
        if (formRow.classList.contains('open-prefixes-list')) {
            formRow.classList.remove('open-prefixes-list');
        }
    });

    // Rimuovi la classe solo se clicchi fuori
    
    // Apertura lista prefissi:
    prefixNumberWrapper.addEventListener('click', () => {
        formRow.classList.toggle('open-prefixes-list');
        
        // Punta focus su searchbar:
        // if (formRow.classList.contains('open-prefixes-list')) {
        //     prefixesSearchbar.focus();
        // }
    });

    // Chiudi lista se clicchi fuori
    window.addEventListener('click', (e) => {
        const clickedOutside = !formRow.contains(e.target);
        if (clickedOutside) {
            formRow.classList.remove('row-is-clicked');
            formRow.classList.remove('open-prefixes-list');
        }
    });

    // Searchbar prefissi:
    prefixesSearchbar.addEventListener('input', () => {
        const searchTerm = prefixesSearchbar.value.trim().toLowerCase();

        prefixesItems.forEach(item => {
            const itemText = item.textContent.toLowerCase();
            const isMatch = itemText.includes(searchTerm);
            item.style.display = isMatch ? 'block' : 'none';
        });
    });

    // Pusha i dati dell'elemento selezionato nei rispettivi campi
    prefixesItems.forEach(item => {
        item.addEventListener('click', () => {
            const prefix = item.dataset.prefix;
            const code = item.dataset.code;

            // Push nei rispettivi wrapper
            spanPrefixNumberWrapper.textContent = prefix;
            prefixNameWrapper.textContent = code;

            // Chiudi la lista
            formRow.classList.remove('open-prefixes-list');

            // Funzione per aggiornare input hidden
            updateFullNumber();
        });
    });
    
    //  Aggiorna mainInput ogni volta che mainInput cambia
    mainInput.addEventListener('input', updateFullNumber);
});